import { edgeConfigClient } from "./client"
import { queryClient } from "@/api/utils/useQuery"
import { EdgeConfigQueries } from "@/api/edgeConfig/queries"
import { IMaintenanceConfig } from "@/mutators/maintenance/MaintenanceMutator.types"
import { cloneInstance } from "@/helpers/objectHelpers"

export const EdgeConfigMutations = {
  maintenance: {
    update: () => ({
      mutationFn: (config: IMaintenanceConfig) =>
        edgeConfigClient.patch("", config),
      invalidateCache: false,
      onSuccessFn: (
        response: unknown,
        maintenanceConfig: IMaintenanceConfig,
      ) => {
        const maintenanceConfigQueryKey =
          EdgeConfigQueries.maintenance.config().queryKey

        queryClient.setQueryData(
          maintenanceConfigQueryKey,
          (maintenanceConfigCache?: IMaintenanceConfig) => {
            if (maintenanceConfigCache) {
              return cloneInstance({
                ...maintenanceConfigCache,
                ...maintenanceConfig,
              })
            }
          },
        )
      },
    }),
  },
}
